import { render, staticRenderFns } from "./InformatizaAps.vue?vue&type=template&id=4cddd8cc"
import script from "./InformatizaAps.vue?vue&type=script&lang=js"
export * from "./InformatizaAps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports